export default __webpack_public_path__ + "static/media/Contrato.2ac5f355.svg";